export default "__VITE_ASSET__f7d49756__"